import type { Store } from 'redux'
import type { IState } from '../redux/reducers'
import { localStorageLog } from '../utils/loggers'
import { Evnt_dispatch } from '../../zap/Evnt/Evnt.dispatch'
import { IDB_dbVersion } from '../../zap/IDB/IDB.initialise'
import type { Type_TDispatch } from '../../zap/Type/Type.hive'
import { type Util_IUnixTime, Util_unixTime } from '../../zap/Util/Util.date'

export let globalHive: Hive = null

export async function initialise(db: IDBDatabase, reduxStore: Store<IState>) {
    globalHive = new Hive(db, reduxStore)
    return globalHive
}

export class Hive implements Hive {
    constructor(db: IDBDatabase, reduxStore: Store<IState>) {
        this.db = db
        this.getState = reduxStore.getState
        this.dispatch = reduxStore.dispatch
        this.lastDBupdate = this.getObj('lastUpdate' + IDB_dbVersion) || {}
    }

    public db: IDBDatabase
    public dispatch: Type_TDispatch
    public getState: Store<IState>['getState']
    private lastDBupdate: { [table: string]: number }

    public getObj<T>(name: string): T {
        localStorageLog(`get ${name}`)
        const data = localStorage.getItem(name)
        if (data === undefined || data === 'undefined') {
            return undefined
        } else {
            return JSON.parse(data)
        }
    }

    public setObj(name: string, value: any) {
        localStorageLog(`set ${name}`)
        try {
            return localStorage.setItem(name, JSON.stringify(value))
        } catch (err) {
            const errStr = err.toString()
            if (errStr.includes('QuotaExceededError') || errStr.includes('QUOTA_EXCEEDED_ERR')) {
                Evnt_dispatch('hive.QuotaExceededError')
            }
            throw err
        }
    }

    public removeObj(name: string) {
        try {
            return localStorage.removeItem(name)
        } catch (e) {
            return false
        }
    }

    public logout = () => {
        this.lastDBupdate = {}
    }

    // Weird key, doesn't need to be versioned
    // Simpler to have a key for each table
    public getLastUpdateName = () => 'lastUpdate' + IDB_dbVersion

    public getlastDBupdate = (table: string) => {
        if (
            this.lastDBupdate[table] !== undefined &&
            this.lastDBupdate[table] !== null &&
            !isNaN(this.lastDBupdate[table])
        ) {
            return Util_unixTime(this.lastDBupdate[table])
        } else {
            return Util_unixTime(0)
        }
    }

    public setlastDBupdate = (table: string, time: Util_IUnixTime) => {
        this.lastDBupdate[table] = time.value

        this.setObj('lastUpdate' + IDB_dbVersion, this.lastDBupdate)
    }
}
